import { DictionaryUUIDsEnum } from 'CorePackage/DictionariesModule/enums/DictionaryUUIDsEnum';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IDictionaryValueTypeById } from 'CorePackage/DictionariesModule/interfaces/IDictionaryValueTypeById';
import { makeGetDictionariesItemValueSelectOption } from 'CorePackage/DictionariesModule/selectors/dictionariesSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

export function getDictionarySelectOptionWithState<T extends DictionaryUUIDsEnum>(
  state: IRootState,
  dictionaryUUID?: DictionaryUUIDsEnum,
  dictionaryVersionUUID?: string,
): IDictionarySelectOption<IDictionaryValueTypeById[T]> {
  return makeGetDictionariesItemValueSelectOption()(state, dictionaryUUID!, dictionaryVersionUUID);
}
